// extracted by mini-css-extract-plugin
export default {"hr":"a16mS","whiteTheme":"b16mS","blueTheme":"c16mS","redTheme":"d16mS","lightTheme":"e16mS","lightInvertedTheme":"f16mS"};